module.exports = __webpack_public_path__ + "static/media/insta.e10b2d2b.svg";